import Vue from 'vue'
import store from './store'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

/**
 * Load all JSON files inside ./src/locales.
 */
function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

//const navigatorLanguage = navigator.language || navigator.userLanguage || ''
//const defaultLocale = navigatorLanguage.substr(0, 2)

//console.log(window.store.getters.langue)
export default new VueI18n({
  //locale: defaultLocale || 'fr',
  locale : store.getters.langue,
  //locale : 'fr',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true
})



// WEBPACK FOOTER //
// ./src/i18n.js